import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";

// import { AuthService } from 'src/app/guards/auth.service';
import { AlertService } from "maps-angular-components";
import { MenuService } from "./menu.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.scss"],
})
export class SideMenuComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();

  @Input() openMenu;
  oneAtATime: boolean = true;
  @Input() showMenu: boolean = true;
  listTeste: any;

  showLink: boolean;
  show: any;

  constructor(
    private alertService: AlertService,
    private menuService: MenuService,
    private changeDetectorRef: ChangeDetectorRef // private authService: AuthService
  ) {}

  ngOnInit() {
    this.checkOpen();
    this.showMenuView();
    this.startMenu();
    this.showMenu = true;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  showMenuView() {
    this.startMenu();
  }

  public isMenuOrSubmenu(link, label): boolean {
    return label === link.label || link.children?.filter(c => c.label === label).length > 0
  }

  startMenu() {
    this.alertService.loadingAlert();
    this.subscriptions.add(
      this.menuService.getUserMenu().subscribe((data: any[]) => {
        this.listTeste = data;
        this.alertService.closeAlert();
        this.changeDetectorRef.detectChanges();
      })
    );
    this.alertService.closeAlert();
    this.changeDetectorRef.detectChanges();
  }

  checkOpen() {
    this.openMenu = true;
  }
}
